import React, { Component } from 'react'
import MainLayout from '../mainLayout/index';
import PlusIcon from '../icons/plusicon';
import { Link } from 'react-router-dom';

import CreateFilmtab from './../component/fpg/create/createFilmTab';
import BeyondFilmtab from '../component/fpg/create/beyondFilmTab';
import NfFilmtab from '../component/fpg/create/nfFilmTab';
import LiveScreeningTab from '../component/fpg/create/LiveScreeningTab';
import TalkEventListTable from '../component/fpg/list/TalkEventListTable';
import FpgFilmTab from '../component/fpg/list/FilmListTable';
import NewFrontierList from '../component/fpg/list/NewFrontierList';
import liveScreening from '../component/fpg/list/liveScreening';
import service from '../services'
import moment from 'moment'
//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor'
import PartnerEventsList from '../component/fpg/list/PartnerEventsList';
import OtherEventsList from '../component/fpg/list/OtherEventsList';
import PartnerEventsCreate from '../component/fpg/create/PartnerEventsCreate';
import OtherEventsCreate from '../component/fpg/create/OtherEventsCreate';
import ScreeningsListTable from '../component/fpg/list/ScreeningsListTable';

let sub;

const mapStateToProps = state => ({
    currentTab: state.currentTab,
    filmEditId: state.filmEditId,
    LiveSceeringEditId: state.LiveSceeringEditId,
    NewFrontierEditDataEditId: state.NewFrontierEditDataEditId,
    TalkEventEditDataEditId: state.TalkEventEditDataEditId,
    partnerEventId: state.partnerEventId,
    otherEventId: state.otherEventId
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};



class FpgFilmCreate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            activetab: '' || 0,
            data: [
                {
                    "label": "FILMS",
                    "Content": "This is content for Tab 1",
                    "tabIndex": 0,
                },
                {
                    "label": "EVENTS",
                    "Content": "This is content for Tab 2",
                    "tabIndex": 1,
                },
                {
                    "label": "SCREENINGS",
                    "Content": "This is content for the Screenings tab",
                    "tabIndex": 5,
                },
                {
                    "label": "NEW FRONTIER",
                    "Content": "This is content for Tab 3",
                    "tabIndex": 2,
                },
                {
                    "label": "PARTNER EVENTS",
                    "Content": "This is content for Tab 4",
                    "tabIndex": 3,
                },
                {
                    "label": "INSTITUTE EVENTS",
                    "Content": "This is content for Tab 5",
                    "tabIndex": 4,
                }
            ]
        }
        this.apiserve = new service();
    }
    TabClick = (index) => {
        this.setState({
            activetab: index
        }, () => {
            if (index === 0) {
                this.props.filmEditData('')
                this.props.CurrentTab(0)
                this.props.history.push('/filmlist')
            }
            if (index === 1) {
                this.props.TalkEventEditData('')
                this.props.CurrentTab(1)
                this.props.history.push('/filmlist')
            }
            if (index === 2) {
                this.props.NewFrontierEditData('')
                this.props.CurrentTab(2)
                this.props.history.push('/filmlist')
            }
            if (index === 3) {
                this.props.PartnerEventsEditData('')
                this.props.CurrentTab(3)
                this.props.history.push('/filmlist')
            }
            if (index === 4) {
                this.props.OtherEventsEditData('')
                this.props.CurrentTab(4)
                this.props.history.push('/filmlist')
            }
            if (index === 5) {
                this.props.CurrentTab(5)
                this.props.history.push('/filmlist')
            }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    NameComparator(a, b) {
        if(a !== undefined && b !== undefined) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
            if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
            return 0;
        }
    }

    componentDidMount = () => {
        var callFrom = this.props.currentTab;

        if (callFrom) {
            this.setState({
                activetab: callFrom
            })
        }
        this.apiserve.sendevent("user|sff|getAllInitial", {host:process.env.REACT_APP_HOST});
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "user|sff|getAllInitial":
                    // response.data.film.screeningTypeList1 = response.data.film.screnningTypeList
                    response.data.film.screeningTypeList1 = Object.assign([],response.data.film.screnningTypeList)
                    let screenTypeList = response.data?.film?.screnningTypeList.filter(item => item.type !== '7' && item.type !== '8')
                    let screenByType = [...new Map(screenTypeList.map(item => [item.type, item])).values()];
                    // response.data.film.screnningTypeList = screenByType
                    response.data.film.screnningTypeList = Object.assign([],screenByType)
                    let sortedCredit = response.data.film.creditLabel.sort(this.NameComparator)
                    this.setState({
                        film: response.data.film,
                        beyondFilm: response.data.beyondFilm,
                        newFrontier: response.data.newFrontier,
                        partnerEvent: response.data.partnerEvent,
                        otherEvent: response.data.otherEvent
                    })
                    break;

                case "film|getLastUpdated":
                    this.setState({
                        getLastUpdated: response.data,
                    })
                    break;

                default:
                    break;
            }
        });
    }

    setLastUpdated = (data) => {
        this.setState({
            getLastUpdated:data
        })
    }

    AddPage = (index) => {
        if (index === 0) {
            this.props.filmEditData('')
            this.TabClick(index)
            this.props.CurrentTab(index)
            this.props.history.push('/create-film')
        }
        if (index === 1) {
            this.props.TalkEventEditData('')
            this.TabClick(index)
            this.props.CurrentTab(index)
            this.props.history.push('/create-film')
        }
        if (index === 2) {
            this.props.NewFrontierEditData('')
            this.TabClick(index)
            this.props.CurrentTab(index)
            this.props.history.push('/create-film')
        }
        if (index === 3) {
            this.props.PartnerEventsEditData('')
            this.TabClick(index)
            this.props.CurrentTab(index)
            this.props.history.push('/create-film')
        }
        if (index === 4) {
            this.props.OtherEventsEditData('')
            this.TabClick(index)
            this.props.CurrentTab(index)
            this.props.history.push('/create-film')
        }
    }

    render() {
        const { getLastUpdated } = this.state
        var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt)
        var hour = moment(updateAt).format('h')
        var minutes = moment(updateAt).format('mm')
        var state = moment(updateAt).format('A')
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy

        return (
            <React.Fragment>
                <div className="right_side_wrapper">
                    <ul className="fpg_admin_tab disp_flex">
                        {
                            this.state.data && this.state.data.map((list) => {
                                const index = list.tabIndex;
                                if(list.label !== 'NEW FRONTIER' && list.label !== 'PARTNER EVENTS'){
                                return (
                                    <li className={this.state.activetab === index ? 'active' : ''}>
                                        <p>
                                            <div onClick={() => this.TabClick(index)}>  {list.label}</div>
                                            {list.label !== 'SCREENINGS' &&
                                                <span id={index} onClick={() => this.AddPage(index)}><PlusIcon /></span>
                                            }
                                        </p>
                                    </li>
                                )
                                }
                            })
                        }
                        
                    </ul>

                    <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <Link className="back_link" to='/filmlist'> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black" /> </svg> Back To List</Link>
                        {this.state.getLastUpdated && this.state.getLastUpdated.updatedAt === undefined ? '' :
                            <p className="update_date">Last Update: {hour}:{minutes} {state} - {moment(updateAt).format('MM/DD/YYYY')} Last Updated By: {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}</p>
                        }
                    </div>
                    {
                        this.props.filmEditId === undefined && this.state.activetab === 0 ?
                            <FpgFilmTab history={this.props.history} />
                            :
                            this.state.activetab === 0 ?
                                <CreateFilmtab film={this.state.film} newFrontier={this.state.newFrontier} history={this.props.history} setLastUpdated={this.setLastUpdated}/>
                                : ''
                    }
                    {
                        this.props.TalkEventEditDataEditId === undefined && this.state.activetab === 1 ?
                            <TalkEventListTable history={this.props.history} />
                            :
                            this.state.activetab === 1 ?
                                <BeyondFilmtab beyondFilm={this.state.beyondFilm} history={this.props.history} setLastUpdated={this.setLastUpdated} />
                                : ''
                    }
                    {
                        this.props.NewFrontierEditDataEditId === undefined && this.state.activetab === 2 ?
                            <NewFrontierList history={this.props.history} />
                            :
                            this.state.activetab === 2 ?
                                <NfFilmtab newFrontier={this.state.newFrontier} history={this.props.history} setLastUpdated={this.setLastUpdated} />
                                : ''
                    }
                    {
                        this.props.partnerEventId === undefined && this.state.activetab === 3 ?
                            <PartnerEventsList history={this.props.history} />
                            :
                            this.state.activetab === 3 ?
                                <PartnerEventsCreate partnerEvent={this.state.partnerEvent} history={this.props.history} setLastUpdated={this.setLastUpdated} />
                                : ''
                    }
                    {
                        this.props.otherEventId === undefined && this.state.activetab === 4 ?
                            <OtherEventsList history={this.props.history} />
                            :
                            this.state.activetab === 4 ?
                                <OtherEventsCreate otherEvent={this.state.otherEvent} history={this.props.history} setLastUpdated={this.setLastUpdated} />
                                : ''
                    }
                    {/* {
                            this.props.LiveSceeringEditId === undefined && this.state.activetab === 3? 
                            <liveScreening history={this.props.history}/>
                            :
                            this.state.activetab === 3 ?
                            <LiveScreeningTab history={this.props.history} />
                            : ''
                        } */}

                    {
                        this.state.activetab === 5 ?
                            <ScreeningsListTable history={this.props.history} />
                            : ''
                    }
                </div>
            </React.Fragment>
        )
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(FpgFilmCreate)